module.exports = __webpack_public_path__ + "media/src/images/balloons/balloons-49aed67d2e272d8aeb3b8f86fdeba4e1.png";